import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationsEn from './locales/en.json';
import translationsIt from './locales/it.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: translationsEn },
    it: { translation: translationsIt }
  },
  lng: 'it',
  fallbackLng: 'it',
  interpolation: { escapeValue: false },
  returnNull: false
});

export default i18n;
